import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from "recharts";

function AgeChart({ ageData }) {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        layout="vertical"
        data={ageData}
        margin={{ top: 20, right: 30, left: 0, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="2 2" />
        <XAxis type="number" />
        <YAxis dataKey="age" type="category" />
        <Tooltip />
        <Legend />
        <Bar dataKey="count" fill="#82ca9d" barSize={20} />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default AgeChart;
